import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { enrollLogout } from "../../services/enrollment";
import GreenCheck from "../../assets/images/icons/GreenCheck.svg";
import Alert from "../../components/Common/Alerts/Alert";
import { ACTION_DISPLAY_TYPES, ICONS } from "../../constants/enums";
import { useHistory } from "react-router-dom";
import { RootState } from "../../types/redux";
import i18n from "../../i18n/config";
import { ROUTES } from "../../constants/clientRoutes";
import PhoneImg from "../../assets/images/rebrand/phone-card.png";

import FlowScreen from "../../components/Layouts/FlowScreen";
import PagePathConstants from "../../constants/page-numbers";
import Action from "../../components/Common/Action";

const Complete = () => {
  const userData = useSelector((state: RootState) => state.enrollment.userData);
  const currentPage = useSelector((state: RootState) => state.enrollment.currentPage);
  const history = useHistory();

  /**
   * Clear localstorage tokens after userData has been received
   */
  useEffect(() => {
    if (currentPage === PagePathConstants.COMPLETE) {
      enrollLogout();
    }

  }, [currentPage]);

  if (currentPage !== PagePathConstants.COMPLETE) {
    return null;
  }

  return (
    <FlowScreen
      className="v3"
      showBackButton={true}
      customBackButtonFunc={() => history.push(ROUTES.AUTH.LOGIN)}
      flowTitle={i18n.t("PAGES.ENROLLMENT.COMPLETE.TITLE")}
    >
      <section className="flex-row justify-content-center align-items-center">
        <div className="text-center min-w-500">
          <img src={GreenCheck} alt="Green Check" className="spacing-bottom-small" style={{ width: "24px" }} />
          <p className="marengo-grey spacing-bottom-small font-size-lg">{i18n.t("PAGES.ENROLLMENT.COMPLETE.SUBTITLE")}</p>
          <p className="marengo-grey font-size-lg spacing-bottom-medium">{i18n.t("PAGES.ENROLLMENT.COMPLETE.P1")}</p>

          <Alert
            alertClasses="alert-info flex-row align-items-start text-left"
            icon={ICONS.INFO}
            iconClasses={"spacing-right-tiny"}
          >
            <p className="bold navy-blue">{i18n.t("PAGES.ENROLLMENT.COMPLETE.USERNAME_ALERT.TITLE")}</p>
            <p>{i18n.t("PAGES.ENROLLMENT.COMPLETE.USERNAME_ALERT.P1")} <span className="bold">{userData?.username}</span></p>
            <p className="spacing-bottom-none">{i18n.t("PAGES.ENROLLMENT.COMPLETE.USERNAME_ALERT.P2")}</p>
          </Alert>

          <Alert alertClasses="alert-info padding-bottom-none">
            <img src={PhoneImg} alt="Phone" className="max-w-300" />
          </Alert>

          {userData?.hasInAppCard &&
            <Alert
              alertClasses="alert-info flex-row align-items-start text-left"
              icon={ICONS.INFO}
              iconClasses={"spacing-right-tiny"}
            >
              <p className="bold">{i18n.t("PAGES.ENROLLMENT.COMPLETE.IN_APP_CARD.ALERT_P1")}</p>
              <p className="spacing-bottom-none">{i18n.t("PAGES.ENROLLMENT.COMPLETE.IN_APP_CARD.ALERT_P2")}</p>
            </Alert>
          }

          <Action
            className="w-full spacing-bottom-large"
            displayType={ACTION_DISPLAY_TYPES.PRIMARY}
            onClick={() => history.push(ROUTES.AUTH.LOGIN)}
            title={i18n.t("COMMON.LOG_IN")}
          />

        </div>
      </section>
    </FlowScreen>
  );
};

Complete.displayName = "CompleteComponent";

export default Complete;
